export const API_CONFIG = {
    ENDPOINTS: {
        AUTH: {
            LOGIN: '/auth/login',
            REFRESH: '/auth/refresh',
            VERIFY: '/auth/verify',
            REGISTER: '/auth/register',
            RESET_PASSWORD: '/auth/reset-password',
            FORGOT_PASSWORD: '/auth/forgot-password',
            ME: '/auth/me'
        },
        PROJECTS: {
            BASE: '/projects',
            LIST: '/projects/',
            USER_PROJECTS: '/projects',
            DETAIL: '/projects/:id',
            CREATE: '/projects/',
            UPDATE: '/projects/',
            DELETE: '/projects/',
            USERS: '/projects/:id/users',
            INVITE: '/projects/:id/invite',
            REMOVE_USER: '/projects/:id/users/:userId',
            UPDATE_USER_ROLE: '/projects/:id/users/:userId',
            UPLOAD_IMAGE: '/projects/upload-image'
        },
        USERS: {
            BASE: '/users',
            ME: '/users/me',
            LIST: '/users/',
            CREATE: '/users/',
            UPDATE: '/users/',
            DELETE: '/users/',
            DETAIL: '/users/:id'
        },
        TEST_RUNS: {
            BASE: '/test-runs',
            LIST: '/test-runs/',
            DETAIL: '/test-runs/:id',
            CREATE: '/test-runs/',
            UPDATE: '/test-runs/:id',
            DELETE: '/test-runs/:id',
            START: '/test-runs/:id/start',
            COMPLETE: '/test-runs/:id/complete',
            ADD_ITEMS: '/test-runs/:id/items',
            ASSIGN_USER: '/test-runs/:id/assign'
        }
    }
}; 